import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TimeZoneService} from '@core/services/time-zone.service';
import {select, Store} from '@ngrx/store';
import {IDashboardState} from '../store/reducer/dashboard-reducer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {Observable} from 'rxjs';
import {hasFeature} from '@shared/store/selectors/security.selector';
import {Input} from '@angular/core';
import {FilterModel} from '@shared/models/filter.models';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {combineLatest, takeUntil} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {Subject} from 'rxjs';
import {getDashBoardCurrentState, getQueryParameters} from '../store/selector/dashboard-selector';
import {SetQueryParams} from '../store/action/dashboard-actions';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'particle-dashboard-filter-toolbar',
  templateUrl: './dashboard-filter-toolbar.component.html',
  styleUrls: ['./dashboard-filter-toolbar.component.scss']
})
export class DashboardFilterToolbarComponent implements OnInit {
  @Input() filterKey: string;

  // hasFeature: boolean = false;
  hasFeature$: Observable<any>;
  filter$: Observable<FilterModel>;
  unSubscribe$ = new Subject<void>();
  dateState: any = {};
  toDay: any;
  VisitorFeature = 'VISITOR';
  queryParams: any;
  private hasVistorFeature: boolean;
  private unsubscribe$ = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  constructor(private store: Store<IQueryState>,
              private dashboardStore: Store<IDashboardState>,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private securityStore: Store<SecurityState>,
              private timeZoneService: TimeZoneService) {
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    this.toDay = this.timeZoneService.dateTostringWithoutUTC(new Date());
    this.hasFeature$ = this.securityStore.pipe(select(hasFeature), takeUntil(this.unsubscribe$));
    if (this.filterKey) {
      this.filter$ = this.store.pipe(select(getQueryResponse, this.filterKey));
      this.hasFeature$.subscribe(feature => {
        if (feature) {
            this.hasVistorFeature = feature(this.VisitorFeature) ? false : true;
        }
      });
    }
    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe(item => {
      if (item) {
        this.queryParams = item;
      }
    });
    QueryProvider.invokeQuery(this.store, this.filterKey, null);
  }
  onDateChange(event) {
    const routingParams = {
      ...this.queryParams,
      fromDate: event.fromDate,
      toDate: event.toDate
    };
    this.router.navigate([], {relativeTo: this.activatedRoute, queryParams: routingParams});
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
